import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AcquiredPageRoutingModule } from './acquired-routing.module';

import { AcquiredPage } from './acquired.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AcquiredPageRoutingModule,
  ],
  declarations: [AcquiredPage],
})
export class AcquiredPageModule {}
